import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  makeStyles,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
  IconButton,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { AUTORIZACIONES_SOLICITUDES_ESTADOS, EMPADRONAMIENTO_MEDICACION_ESTADOS } from "../../../../utils/constants";
import { getNotasPorSolicitudMedicacion, getTiposNotasTodasEmpadronamiento } from "../../../../actions/empadronamiento/Empadronamiento";
import { Note } from "@material-ui/icons";
import { ModalNotasMedicacion } from "./ModalNotasMedicacion";
import { ModalDeleteMed } from "./ModalDeleteMed";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const useStyles = makeStyles({
  hoverNota: {
    "&:hover": {
      backgroundColor: "#80808026",
      cursor: "pointer",
    },
  },
});

export const NotasMenuMedicacion = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { notasMed = [], solicitudSeleccionada = {}, tiposNotasEmp = [] } = useSelector(
    (state) => state.empadronamiento
  );
  const { idUsuario } = useSelector(
    (state) => state.auth
  );

  const [openModal, setOpenModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("");
  const [editNota, setEditNota] = useState(null);
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [idNotaDelete, setIdNotaDelete] = useState(false);

  let idSolicitud = null;

  if (solicitudSeleccionada) {
    idSolicitud = solicitudSeleccionada?.idSolicitud;
  }

  useEffect(() => {
    dispatch(getNotasPorSolicitudMedicacion(idSolicitud));
  }, []);

  useEffect(() => {
    dispatch(getTiposNotasTodasEmpadronamiento());
  }, []);

  return (
    <React.Fragment>
      {openModal && (
        <ModalNotasMedicacion
          open={openModal}
          close={() => {
            setOpenModal(false);
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idSolicitud={idSolicitud}
          disabled={solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA ?
            false : props.disabled}
          titulo={tituloModal}
          nota={editNota}
          privada={editNota ? false : true}
        />
      )}
      {openDeleteModal && (
        <ModalDeleteMed
          open={openDeleteModal}
          close={() => {
            setDeleteModal(false);
          }}
          idSolicitud={idSolicitud}
          idNotaDelete={idNotaDelete}
        />
      )}
      <div style={{ textAlign: "center", margin: "1rem 0" }}>
        <Button
          disabled={solicitudSeleccionada?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA ?
            false : props.disabled}
          variant="contained"
          color="primary"
          onClick={() => {
            setTituloModal("Agregar Nota");
            setEditNota(null);
            setOpenModal(true);
          }}
        >
          + Agregar Nota
        </Button>
      </div>
      {Array.isArray(notasMed) && notasMed?.length > 0 ? (
        <List>
          {notasMed.map((nota) => (
            <ListItem
              key={nota.idNota}
              className={classes.hoverNota}
              onClick={() => {
                setTituloModal("Editar Nota");
                setEditNota(nota);
                setOpenModal(true);
              }}
            >
              <ListItemAvatar>
                <Note
                  color={"#00abfb"}
                />
              </ListItemAvatar>
              <ListItemText
                primary={
                  `${tiposNotasEmp.find(t => t.idTipoNota === nota.idTipoNota)?.descripcion} - ${nota.usuario.userName}`
                }
                secondary={
                  `${new Date(nota.fecha).toLocaleString(
                    "es",
                    optionsfecha
                  )} - ${new Date(nota.fecha).toLocaleTimeString("es", {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}hs`
                }
              />
              {nota.idUsuario === idUsuario && (
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    onClick={() => {
                      setDeleteModal(true);
                      setIdNotaDelete(nota.idNota);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography
          style={{
            fontSize: "1.1rem",
            fontStyle: "italic",
            marginBottom: "1rem",
          }}
        >
          No hay notas
        </Typography>
      )}
    </React.Fragment>
  );
};
